import '@/api'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './registerServiceWorker'
import moment from 'moment'
import VueSocketIO from 'vue-socket.io'
import socketio from 'socket.io-client'
import VueLodash from 'vue-lodash'
import BootstrapVue from 'bootstrap-vue'
import PortalVue from 'portal-vue'
import IdleVue from 'idle-vue'

const options = { name: 'lodash' }
Vue.use(VueLodash, options)
Vue.use(BootstrapVue)
Vue.use(PortalVue)
const eventsHub = new Vue()
 
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime:900000,
  events: ['keydown', 'mousedown', 'touchstart']
})


/*Vue.use(new VueSocketIO({
    debug: true,
    connection: socketio('https://gamexyz.darkiosys.com'), //options object is Optional
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_"
    }
  })
);*/

Vue.config.silent = true
Vue.config.productionTip = false
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
  }
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
